import { IItem } from "@coreui/angular-pro";
import { PipelineDashboardData, pipelineLineCharts, pipelinePieCharts, pipelineStats } from "src/Models/pipeline.model";
import { environment } from "src/environments/environment";
import { DatePipe, getLocaleId } from "@angular/common";

export class PipelineDashboardControler{
  private pipelineDashboardData:PipelineDashboardData[];

	constructor($pipelineDashboardData: PipelineDashboardData[]) {
		this.pipelineDashboardData = $pipelineDashboardData;
	}

  private PipelinePortfolio(chartData:pipelinePieCharts, itm: PipelineDashboardData){
    if(!chartData.dataLables.includes(itm.productType)){
      chartData.dataLables.push(itm.productType)
      chartData.dataSet.push(0);
    }
    chartData.dataSet[chartData.dataLables.indexOf(itm.productType)]++;
  }

  public PipelineStats():pipelineStats {
    let stats = new pipelineStats();
    if(this.pipelineDashboardData)
    this.pipelineDashboardData.forEach(itm => {
      switch (itm.pipelineStageTypeID.toLowerCase()) {
        case environment.pipeline.pipelineStageTypeIds.Prospect:{
          stats.countProspect++;
          stats.Prospect += itm.expectedGP;
          this.PipelinePortfolio(stats.ProspectChart, itm);
          break;}
        case environment.pipeline.pipelineStageTypeIds.InitialContactMade:{
          stats.countContacted++;
          stats.Contacted += itm.expectedGP;
          this.PipelinePortfolio(stats.ContactedChart, itm);
          break;}
        case environment.pipeline.pipelineStageTypeIds.Met:{
          stats.countVisited++;
          stats.Visited += itm.expectedGP;
          this.PipelinePortfolio(stats.VisitedChart, itm);
          break;}
        case environment.pipeline.pipelineStageTypeIds.ProposalSent:{
          stats.countProposal++;
          stats.Proposal += itm.expectedGP;
          this.PipelinePortfolio(stats.ProposalChart, itm);
          break;}
        case environment.pipeline.pipelineStageTypeIds.Closed_Won:{
          stats.countWon++;
          stats.Won += itm.expectedGP;
          this.PipelinePortfolio(stats.WonChart, itm);
          break;}
        case environment.pipeline.pipelineStageTypeIds.Closed_Lost:{
          stats.countLost++;
          stats.Lost += itm.expectedGP;
          this.PipelinePortfolio(stats.LostChart, itm);
          break;}
        default:{
          //log error here
          }
      }

      this.PipelinePortfolio(stats.pipelinePortifolio, itm);
    });

    return stats;
  }

  public PipelineActivity(startDate: Date | null | undefined, endDate: Date | null | undefined): pipelineLineCharts {
    let chartData = new pipelineLineCharts();
    let dtp = new DatePipe(getLocaleId(navigator.language));
    let addYear = false;
    if (startDate && endDate){
      addYear = endDate.getFullYear() - startDate.getFullYear() > 0;
      const startWeek = dtp.transform(startDate, 'w');
      const weekDiff = Math.round(((endDate.getTime() - startDate.getTime())/1000)/(60 * 60 * 24 * 7));

      if(startWeek != null ){
        let counter = +startWeek;
        let year = startDate.getFullYear();
        let maxWeekInYear = dtp.transform((new Date(year, 11, 31)), 'w');
        if (maxWeekInYear && +maxWeekInYear === 1)
          maxWeekInYear = dtp.transform((new Date(year, 11, 25)), 'w');

        while (chartData.dates.length <= weekDiff){
          if (maxWeekInYear != null && counter > +maxWeekInYear){
            year += 1;
            counter = 1;
            maxWeekInYear = dtp.transform(new Date(year, 11, 31), 'w');
            if (maxWeekInYear && +maxWeekInYear === 1)
              maxWeekInYear = dtp.transform((new Date(year, 11, 25)), 'w');
          }
          chartData.dates.push(addYear ? (counter.toString() + ' ('+ year + ')') : counter.toString());
          counter += 1;
        }
      }
    }

    if(this.pipelineDashboardData)
    this.pipelineDashboardData.forEach(itm => {
      //let date = monthNames[itm.month-1] + " " + itm.year;
      let date = addYear? (itm.week.toString() + ' ('+ itm.year.toString() + ')') : itm.week.toString();
      chartData.incrementDataForLabel(itm.pipelineStageTypeID.toLowerCase(), date);
    });
    return chartData;
  }

  public getRawData(stage?:string, productType?:string):IItem[]{
    let oList:IItem[] = [];
    if(this.pipelineDashboardData){
      if (!!productType){
        let i = productType.lastIndexOf(" ");
        productType = productType.substring(0, i);
        console.log(productType);
      }
      const filteredData = this.pipelineDashboardData.filter( itm => (productType == undefined ||  itm.productType == productType) && (stage  == undefined || itm.pipelineStageTypeID == stage)).map(itm => {
        const temp = {
          "Customer_Name": itm.customerName,
          "Routing": itm.origin==null || itm.destination==null? "n/a" : itm.origin + " → " + itm.destination,
          "Product_Type": productType? itm.product : itm.productType + ' ' + itm.product,
          "Volume": itm.estimatedVolume,
          "Unit": itm.unit,
          "Expected_GP": itm.expectedGP,
          "Stage": itm.pipelineStage == "Met"? "Visited" : itm.pipelineStage,
          "Sales_Rep": itm.assignedTo,
          "Comment": itm.comments
        }
        return temp
      });
      filteredData.forEach( itm => {oList.push(itm)});
    }
    return oList;
  }
}
